import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import { initAuth } from './utils/auth';
import { loadConfig } from './utils/config';
import './design/tokens.css';
import './design/bundle.css';
import './style.css';

// The design system's dark theme follows the system setting (tokens.css: [data-theme="dark"]).
const darkQuery = window.matchMedia('(prefers-color-scheme: dark)');
const applyTheme = () => (document.documentElement.dataset.theme = darkQuery.matches ? 'dark' : 'light');
applyTheme();
darkQuery.addEventListener('change', applyTheme);

async function bootstrap() {
  await loadConfig();
  // Completes the Cognito redirect or ensures a valid session (redirecting to the hosted UI if needed).
  await initAuth();
  createApp(App).use(router).mount('#app');
}

bootstrap().catch((err: unknown) => {
  const message = err instanceof Error ? err.message : String(err);
  document.getElementById('app')!.innerHTML =
    `<div class="fx-page"><div class="error-banner"></div><a href="/">Try again</a></div>`;
  document.querySelector('.error-banner')!.textContent = message;
});
